import { Controller } from '@hotwired/stimulus'

import { withAjaxDatatable } from '../../src/mixins/with_ajax_datatable'
import { withClickableRows } from '../../src/mixins/with_clickable_rows'

export default class extends Controller {
  static targets = ['datatable']
  static values = {
    filters: { type: Object, default: {} },
    columns: {
      type: Array,
      default: [
        { data: 'name' },
        { data: 'date' },
        { data: 'pilot' },
        { data: 'drone', orderable: false },
        { data: 'airtime', className: 'numerical' }
      ]
    },
    source: String
  }

  connect () {
    withAjaxDatatable(this, this.datatableTarget, {
      source: this.sourceValue,
      columns: this.columnsValue,
      order: [[1, 'desc']],
      applyFilters: (data) => {
        const filters = Object.assign(data.filter || {}, this.filtersValue)
        data.filter = filters
      },
      updateCallback: (data) => {
        this.dispatch('datatableUpdated', { detail: data })
      }
    })

    // Add Clickable Rows
    withClickableRows(this.datatableTarget)
  }
}
